export default __webpack_public_path__ + "static/BayswaterCarousel_0006-2b4b880fe15de169594f5932460e155a.jpg";